export default __webpack_public_path__ + "static/media/upgrade-report15.d2b83c43.png";